import React, { useEffect, useState } from "react";
import { Card, message, Form, Spin, Layout } from "antd";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import UserForm from "../../../Components/Form/UserForm";
import Sidebar from "../../../Components/Sidebar";
import { BASE_URL } from "../../../Config";

const EditUserPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      setPageLoading(true);
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/users/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      form.setFieldsValue(res.data.data);
    } catch (error) {
      message.error("Failed to load user");
    } finally {
      setPageLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");

      await axios.put(`${BASE_URL}/users/${id}`, values, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      message.success("User updated successfully");
      navigate("/allpages");
    } catch (error) {
      message.error(error.response?.data?.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <div
        style={{
          marginLeft: isMobile ? "0px" : collapsed ? "80px" : "200px",
          transition: "0.3s ease",
          width: "100%",
        }}
      >
        <Card title="Edit User" style={{ maxWidth: 500, margin: "auto" }}>
          {pageLoading ? (
            <Spin size="large" />
          ) : (
            <UserForm
              form={form}
              onFinish={onFinish}
              loading={loading}
              isEdit
            />
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default EditUserPage;
